/* unplugin-vue-components disabled */import { render } from "./exhibition.vue?vue&type=template&id=f76d86e2&scoped=true"
import script from "./exhibition.vue?vue&type=script&lang=js"
export * from "./exhibition.vue?vue&type=script&lang=js"

import "./exhibition.vue?vue&type=style&index=0&id=f76d86e2&scoped=true&lang=scss"
import "./exhibition.vue?vue&type=style&index=1&id=f76d86e2&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f76d86e2"]])

export default __exports__